import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import Merchant from '../../../domain/entities/Merchant';
import DateTimeUtils from '../../utils/DateTimeUtils';
import StringUtils from '../../utils/StringUtils';
import css from './MerchantProfile.module.scss';

interface Props extends InjectedIntlProps {
  merchant: Merchant;
}

const MerchantProfile = ({ merchant, intl }: Props) => {
  const addressLink = merchant.address
    ? `https://www.google.co.jp/maps/place/${encodeURI(
        merchant.address.replace(/\r?\n/g, ' '),
      )}`
    : undefined;
  let businessHoursTexts: string[] = [];
  if (merchant.businessHours.length > 0) {
    businessHoursTexts = DateTimeUtils.formatBusinessHours(
      merchant.businessHours,
    );
  }

  return (
    <dl className={css.MerchantProfile}>
      {merchant.address && (
        <div className={css.MerchantProfile__Row}>
          <dt className={css.MerchantProfile__RowHead}>
            {intl.formatMessage({ id: 'merchants.details.address' })}
          </dt>
          <dd>
            <span>{StringUtils.nl2br(merchant.address)}</span>
            <br />
            <a
              className={css.MerchantProfile__RowBodySubLink}
              href={addressLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({ id: 'merchants.details.openMap' })}
            </a>
          </dd>
        </div>
      )}
      {merchant.phoneNumber && (
        <div className={css.MerchantProfile__Row}>
          <dt className={css.MerchantProfile__RowHead}>
            {intl.formatMessage({ id: 'merchants.details.phoneNumber' })}
          </dt>
          <dd>
            <a href={`tel:${merchant.phoneNumber}`}>{merchant.phoneNumber}</a>
          </dd>
        </div>
      )}
      {businessHoursTexts.length !== 0 && (
        <div className={css.MerchantProfile__Row}>
          <dt className={css.MerchantProfile__RowHead}>
            {intl.formatMessage({ id: 'merchants.details.businessHours' })}
          </dt>
          <dd>
            {businessHoursTexts.map((txt, i) => (
              <p className={css.MerchantProfile__BusinessHourText} key={i}>
                {txt}
              </p>
            ))}
          </dd>
        </div>
      )}
    </dl>
  );
};

export default injectIntl(MerchantProfile);
